import { logger } from '@ustra/core'
import { UtraService } from '@ustra/nuxt/src/services/ustra-service'

// Native Call
export enum NativeCall {
  // Type
  TYPE_BIO = '00', // 생체인증
  TYPE_PATN = '01', // 패턴인증

  // State
  STATE_REG = '00',
  STATE_UNREG = '01',
  STATE_NOT_SUPPORT = '02',
  STATE_BIO_LOCK = '03', // djyoo 21.08.31 iPhone은 등록 실패 여러번하면 lock 걸림.

  // IF_2ND_REG 요청 시 수행할 작업
  EXEC_REG = '00', // 등록
  EXEC_DEL = '01', // 삭제

  RES_SUCCESS = '0000', // 성공
  RES_FAIL = '9999', // 실패
}

// Bridge 통신 규약
export enum BridgeRes {
  BRIDGE_RES_OK = '0000', // 정상
  BRIDGE_RES_INVALID_PARAM = '5001', // 적합하지 않은 요청 파라미터
  BRIDGE_RES_EXP_INT_TOKEN = '5002', // 만료된 인터페이스 토큰
  BRIDGE_RES_INVALID_INT_TOKEN = '5003', // 유효하지않은 인터페이스 토큰
  BRIDGE_RES_INVALID_APP_KEY = '5004', // APP KEY 불일치
  BRIDGE_RES_INVALID_ITF_ID = '5005', // 유효하지않은 인터페이스 아이디
  BRIDGE_RES_NO_PERMISSION = '0401', // 인터페이스 호출 권한 없음
  BRIDGE_RES_INVALID_TOKEN = '0402', // 유효하지않은 토큰 정보
  BRIDGE_RES_TIMEOUT = '9998', // 타임아웃
  BRIDGE_RES_ERROR_ETC = '9999', // 기타오류
}

interface NativeCallResult {
  resCd?: string
  message?: string
  state?: {
    bioState?: string
    patnState?: string
  }
}

// export interface NatvieMobileCall {
//   type: string
//   execute: string
// }

export class MobileService extends UtraService {
  checkState(callback: (result: NativeCallResult) => void) {
    const callResult: NativeCallResult = {}
    this.$ustra.mobile.bridge.callNative({
      id: 'IF_2ND_CHK',
      data: {},
      callback: (result) => {
        if (result.timeout || result.resCode !== BridgeRes.BRIDGE_RES_OK || result.data === null) {
          // 에러 처리
          callResult.resCd = NativeCall.RES_FAIL
          callResult.message = '인증 체크에 실패하였습니다.'
          return
        }

        callResult.resCd = NativeCall.RES_SUCCESS
        callResult.state = {
          bioState: result.data.bioEnable,
          patnState: result.data.patternEnable,
        }

        logger().debug({ message: '생체인증 체크 응답 : ', args: [result.data.bioEnable] })
        logger().debug({ message: '패턴인증 체크 응답 : ', args: [result.data.patternEnable] })

        callback(callResult)
      },
      timeout: 2000,
      useToken: false,
    })

    return callResult
  }

  regBio(callback: (result: NativeCallResult) => void) {
    const callResult: NativeCallResult = {}
    this.$ustra.mobile.bridge.callNative({
      id: 'IF_2ND_REG',
      data: { type: NativeCall.TYPE_BIO, execute: NativeCall.EXEC_REG },
      callback: (result) => {
        if (result.timeout || result.resCode !== BridgeRes.BRIDGE_RES_OK || result.data === null) {
          //  에러 처리
          callResult.resCd = NativeCall.RES_FAIL
          callResult.message = '생체 인증 등록에 실패하였습니다.'

          callback(callResult)
          return
        }

        logger().debug({ message: '생체인증 등록 응답 : ', args: [result.data.success] })
        if (result.data.success) {
          if (result.data.execute === NativeCall.EXEC_REG) {
            callResult.resCd = NativeCall.RES_SUCCESS
            callResult.message = '생체 인증 등록에 성공하였습니다.'
          } else {
            // 발생하면 안되는 케이스
            // 실패 처리
            callResult.resCd = NativeCall.RES_FAIL
            callResult.message = '생체 인증 등록에 실패하였습니다.'
          }
        } else {
          //  실패 처리
          callResult.resCd = NativeCall.RES_FAIL
          callResult.message = '생체 인증 등록에 실패하였습니다.'
        }

        callback(callResult)
      },
      timeout: 0,
      useToken: false,
    })

    return callResult
  }

  delBio(callback: (result: NativeCallResult) => void) {
    const callResult: NativeCallResult = {}
    this.$ustra.mobile.bridge.callNative({
      id: 'IF_2ND_REG',
      data: { type: NativeCall.TYPE_BIO, execute: NativeCall.EXEC_DEL },
      callback: (result) => {
        if (result.timeout || result.resCode !== BridgeRes.BRIDGE_RES_OK || result.data === null) {
          // 에러 처리
          callResult.resCd = NativeCall.RES_FAIL
          callResult.message = '생체 인증 등록 해제에 실패하였습니다.'

          callback(callResult)
          return
        }

        logger().debug({ message: '생체 인증 등록 해제 응답 : ', args: [result.data.success] })
        if (result.data.success) {
          if (result.data.execute === NativeCall.EXEC_DEL) {
            callResult.resCd = NativeCall.RES_SUCCESS
            callResult.message = '생체 인증 해제에 성공하였습니다.'
          } else {
            // 발생하면 안되는 케이스
            callResult.resCd = NativeCall.RES_FAIL
            callResult.message = '생체 인증 등록 해제에 실패하였습니다.'
          }
        } else {
          //  실패 처리
          callResult.resCd = NativeCall.RES_FAIL
          callResult.message = '생체 인증 등록 해제에 실패하였습니다.'
        }

        callback(callResult)
      },
      timeout: 0,
      useToken: false,
    })

    return callResult
  }

  regPatn(callback: (result: NativeCallResult) => void) {
    const callResult: NativeCallResult = {}
    this.$ustra.mobile.bridge.callNative({
      id: 'IF_2ND_REG',
      data: { type: NativeCall.TYPE_PATN, execute: NativeCall.EXEC_REG },
      callback: (result) => {
        if (result.timeout || result.resCode !== BridgeRes.BRIDGE_RES_OK || result.data === null) {
          // 에러 처리
          callResult.resCd = NativeCall.RES_FAIL
          callResult.message = '패턴 인증 등록에 실패하였습니다.'

          callback(callResult)
          return
        }

        logger().debug({ message: '패턴 등록 응답 : ', args: [result.data.success] })
        if (result.data.success) {
          if (result.data.execute === NativeCall.EXEC_REG) {
            callResult.resCd = NativeCall.RES_SUCCESS
            callResult.message = '패턴 인증 등록에 성공하였습니다.'
          } else {
            // 발생하면 안되는 케이스
            callResult.resCd = NativeCall.RES_FAIL
            callResult.message = '패턴 인증 등록에 실패하였습니다.'
          }
        } else {
          // 실패 처리
          callResult.resCd = NativeCall.RES_FAIL
          callResult.message = '패턴 인증 등록에 실패하였습니다.'
        }

        callback(callResult)
      },
      timeout: 0,
      useToken: false,
    })
    return callResult
  }

  delPatn(callback: (result: NativeCallResult) => void) {
    const callResult: NativeCallResult = {}
    this.$ustra.mobile.bridge.callNative({
      id: 'IF_2ND_REG',
      data: { type: NativeCall.TYPE_PATN, execute: NativeCall.EXEC_DEL },
      callback: (result) => {
        if (result.timeout || result.resCode !== BridgeRes.BRIDGE_RES_OK || result.data === null) {
          //  에러 처리
          callResult.resCd = NativeCall.RES_FAIL
          callResult.message = '패턴 인증 등록 해제에 실패하였습니다.'

          callback(callResult)
          return
        }

        logger().debug({ message: '패턴 인증 등록 해제 응답 : ', args: [result.data.success] })
        if (result.data.success) {
          if (result.data.execute === NativeCall.EXEC_DEL) {
            callResult.resCd = NativeCall.RES_SUCCESS
            callResult.message = '패턴 인증 등록 해제에 성공하였습니다.'
          } else {
            // 발생하면 안되는 케이스
            callResult.resCd = NativeCall.RES_FAIL
            callResult.message = '패턴 인증 등록 해제에 실패하였습니다.'
          }
        } else {
          //  실패 처리
          callResult.resCd = NativeCall.RES_FAIL
          callResult.message = '패턴 인증 등록 해제에 실패하였습니다.'
        }

        callback(callResult)
      },
      timeout: 0,
      useToken: false,
    })
    return callResult
  }

  bioAuth(callback: (result: NativeCallResult) => void) {
    const callResult: NativeCallResult = {}
    this.$ustra.mobile.bridge.callNative({
      id: 'IF_2ND_AUTH',
      data: { type: NativeCall.TYPE_BIO },
      callback: (result) => {
        if (result.timeout || result.resCode !== BridgeRes.BRIDGE_RES_OK || result.data === null) {
          // 에러 처리
          callResult.resCd = NativeCall.RES_FAIL
          callResult.message = '생체 인증에 실패하였습니다.'

          callback(callResult)
          return
        }

        logger().debug({ message: '생체인증 요청 응답 : ', args: [result.data.success] })
        if (result.data.success) {
          // 생체인증 성공
          callResult.resCd = NativeCall.RES_SUCCESS
          callResult.message = '생체 인증에 성공하였습니다.'
        } else {
          // 실패 처리
          callResult.resCd = NativeCall.RES_FAIL
          callResult.message = '생체 인증에 실패하였습니다.'
        }

        callback(callResult)
      },
      timeout: 0,
      useToken: false,
    })

    return callResult
  }

  patnAuth(callback: (result: NativeCallResult) => void) {
    const callResult: NativeCallResult = {}
    this.$ustra.mobile.bridge.callNative({
      id: 'IF_2ND_AUTH',
      data: { type: NativeCall.TYPE_PATN },
      callback: (result) => {
        if (result.timeout || result.resCode !== BridgeRes.BRIDGE_RES_OK || result.data === null) {
          // 에러 처리
          callResult.resCd = NativeCall.RES_FAIL
          callResult.message = '패턴 인증에 실패하였습니다.'

          callback(callResult)
          return
        }

        logger().debug({ message: '패턴 요청 응답 : ', args: [result.data.success] })
        if (result.data.success) {
          // 패턴인증 성공
          callResult.resCd = NativeCall.RES_SUCCESS
          callResult.message = '패턴 인증에 성공하였습니다.'
        } else {
          // 실패 처리
          callResult.resCd = NativeCall.RES_FAIL
          callResult.message = '패턴 인증에 실패하였습니다.'
        }

        callback(callResult)
      },
      timeout: 0,
      useToken: false,
    })

    return callResult
  }

  tms(userId: string, venCd: string, venNm: string, ven2Cd: string, ven2Nm: string, autoLogin: boolean) {
    const callResult: NativeCallResult = {}
    this.$ustra.mobile.bridge.callNative({
      id: 'IF_TMS',
      data: { userId, venCd, venNm, ven2Cd, ven2Nm, autoLogin },
      callback: () => {},
      timeout: 60000,
      useToken: false,
    })

    return callResult
  }
}

export const mobileService = new MobileService()
export default mobileService
